import axios from 'utils/axios';

export const uploadPhotosForProperties = (formData) =>
  axios
    .post('/api/admin/bulk-photo-upload', formData, { headers: { 'Content-type': 'multipart/form-data' } })
    .then((res) => res.data);
